import { createFileRoute, redirect } from '@tanstack/react-router';
import { Billing } from '@/components/settings/billing';
import { PageHeader } from '@/components/page-header';
import { PageContent } from '@/components/page-content';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings_/billing')({
  component: BillingSettingsPage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { billing: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function BillingSettingsPage() {
  return (
    <>
      <PageHeader
        title="Billing"
        description="Manage your subscription and usage."
      />
      <PageContent>
        <Billing />
      </PageContent>
    </>
  );
}
